import { objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useMemo } from 'react';
import { useListContext } from './list-context.esm.js';
import { useSafeThemeUI } from '../../theme-provider/use-theme-ui.esm.js';
import extractStringNodes from '../../utils/extract-string-nodes.esm.js';
import { get } from '../../utils/object.esm.js';
import { resolveSize, getNextSize } from '../../utils/size-utils.esm.js';
import { FlexPrivate } from '../_primitives/flex/flex.esm.js';
import { TextPrivate } from '../_primitives/text/text.esm.js';

var _excluded = ["className", "children", "disableTextWrap", "inset", "primary", "primaryTextProps", "secondary", "secondaryTextProps", "size", "disabled"];
var ListItemText = /*#__PURE__*/React.forwardRef(function ListItemText(props, ref) {
  var className = props.className,
    children = props.children,
    disableTextWrap = props.disableTextWrap,
    _props$inset = props.inset,
    inset = _props$inset === void 0 ? false : _props$inset,
    primaryNode = props.primary,
    primaryTextProps = props.primaryTextProps,
    secondaryNode = props.secondary,
    secondaryTextProps = props.secondaryTextProps,
    size = props.size,
    disabled = props.disabled,
    rest = _objectWithoutProperties(props, _excluded);
  var _useListContext = useListContext(),
    dense = _useListContext.dense;
  var theme = useSafeThemeUI(props);
  var fontSize = resolveSize(size, get(theme, 'sizes.font'));
  var secondaryFontSize = resolveSize(Array.isArray(size) ? size.map(function (i) {
    return getNextSize(i, -1);
  }) : getNextSize(size, -1), get(theme, 'sizes.font'));
  var primaryChildren = primaryNode != null ? primaryNode : children;
  if (!disableTextWrap) {
    var primaryStringNode = extractStringNodes(React.Children.toArray(primaryChildren).filter(function (i) {
      return typeof i === 'string';
    }));
    if (primaryStringNode != null && primaryStringNode.length > 0) {
      primaryChildren = /*#__PURE__*/React.createElement(TextPrivate, _extends({
        className: "csg-tui-list-item-text-primary",
        ellipsis: true
      }, _objectSpread2({
        fontSize: fontSize
      }, primaryTextProps)), primaryChildren);
    }
  }
  var secondaryChildren = secondaryNode != null ? secondaryNode : [];
  if (!disableTextWrap) {
    var secondaryStringNode = extractStringNodes(React.Children.toArray(secondaryChildren).filter(function (i) {
      return typeof i === 'string';
    }));
    if (secondaryStringNode != null && secondaryStringNode.length > 0) {
      secondaryChildren = /*#__PURE__*/React.createElement(TextPrivate, _extends({
        className: "csg-tui-list-item-text-secondary",
        ellipsis: true
      }, _objectSpread2({
        fontSize: secondaryFontSize,
        color: 'neutral.dark'
      }, secondaryTextProps)), secondaryChildren);
    }
  }
  var __css = useMemo(function () {
    return _objectSpread2(_objectSpread2(_objectSpread2({
      flexDirection: 'column',
      flex: '1 1 auto',
      gap: 'xs-3',
      minWidth: 0
    }, inset ? {
      pl: '56px'
    } : {}), primaryChildren && secondaryNode ? {
      my: dense ? 'xs-2' : 'xxs'
    } : {
      my: dense ? 'xs-3' : 'xs-2'
    }), {}, {
      '&.is-disabled': {
        pointerEvents: 'none'
      }
    });
  }, [dense, inset, primaryChildren, secondaryNode]);
  // eslint-disable-next-line no-console
  // console.log(`---- render theme-ui.list-item-text ----`)
  return /*#__PURE__*/React.createElement(FlexPrivate, _extends({
    ref: ref,
    className: classNames('csg-tui-list-item-text', className, {
      'is-disabled': disabled
    }),
    __css: __css
  }, rest), primaryChildren, secondaryChildren);
});

export default ListItemText;
//# sourceMappingURL=list-item-text.esm.js.map
